<div class="gis-anomalies-shell">
  <h2 class="gis-anomalies-region-path">{{ regionPathDisplay }}</h2>
  <div class="gis-anomalies-map-wrap">
    <div class="fields-summary-header">
      <span>{{ 'Number of anomalies' | translate }}: <strong>{{ anomaliesCount }}</strong></span>
    </div>
    <aside
      class="gis-anomalies-legend"
      role="region"
      [attr.aria-label]="'ANOMALY_MAP_LEGEND_TITLE' | translate"
    >
      <div class="gis-anomalies-legend__title">{{ 'ANOMALY_MAP_LEGEND_TITLE' | translate }}</div>
      <div class="gis-anomalies-legend__row">
        <span
          class="gis-anomalies-legend__swatch gis-anomalies-legend__swatch--field"
          [style.border-bottom]="'2px dashed ' + fieldOutlineLegendColor"
        ></span>
        <span class="gis-anomalies-legend__label">{{ 'ANOMALY_MAP_LEGEND_FIELD_BOUNDARY' | translate }}</span>
      </div>
      @for (item of anomalyLegendItems; track item.anomalyType) {
        <div class="gis-anomalies-legend__row">
          <span
            class="gis-anomalies-legend__swatch"
            [style.background-color]="anomalyTypeColors[item.anomalyType]"
          ></span>
          <span class="gis-anomalies-legend__label">{{ item.labelKey | translate }}</span>
        </div>
      }
    </aside>
    <app-openstreetmap
      [mapController$]="mapController$"
      [mapOptions]="mapOptions"
      (mapReady)="onMapReady()"
      class="gis-anomalies-map"
    ></app-openstreetmap>
  </div>
</div>
